import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import Button from '@dojo/widgets/button';
import { convertToBoolean } from '@holmescorp/common';
import { CountdownTimer } from '../widgets/countdown-timer';
import css from '../css/numeric-entry.m.css';
import NumericEntryBase from './ne-base';
let NEQuestionPretest = class NEQuestionPretest extends NumericEntryBase {
    render_buttons(which) {
        const { messages: { finish: finishText = '', submit: submitText = '', show_pretest_timer = 'true' } } = this.properties.localizedBundle;
        const { quizstore, onNextQuestion, onFinish, theme } = this.properties;
        const { islast = false } = which;
        const showTimer = convertToBoolean(show_pretest_timer);
        const buttons = [
            islast
                ? w(Button, {
                    key: 'finish',
                    onClick: async () => {
                        if (!this._inFinish) {
                            this._inFinish = true;
                            this.set_iscorrect();
                            await this.update_result();
                            onFinish();
                        }
                    }
                }, [finishText])
                : w(Button, {
                    theme,
                    key: 'submit',
                    onClick: () => {
                        if (!this._inSubmit) {
                            this._inSubmit = true;
                            this.set_iscorrect();
                            this.update_result().then(() => {
                                onNextQuestion();
                            });
                        }
                    }
                }, [submitText]),
            showTimer
                ? v('div', { key: 'timer', classes: [this.theme(css.timerblock)] }, [
                    v('div', { classes: [this.theme(css.timer)] }, [
                        w(CountdownTimer, { quizstore, countdown: '' })
                    ])
                ])
                : null
        ];
        return buttons;
    }
    render() {
        return this.render_question();
    }
};
NEQuestionPretest = __decorate([
    theme(css)
], NEQuestionPretest);
export { NEQuestionPretest };
export default NEQuestionPretest;
